var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.007a1 1 0 0 1 .993.883l.007.117v9.995a3.006 3.006 0 0 1-2.824 2.993L16 22H8c-1.6 0-2.904-1.25-2.995-2.822L5 19.002V9.007a1 1 0 0 1 1.993-.117L7 9.007v9.995a1 1 0 0 0 .883.992l.117.007h8c.509 0 .935-.39.993-.884l.007-.115V9.007a1 1 0 0 1 1-1zm-4 1a1 1 0 0 1 .993.883l.007.116v6.997a1 1 0 0 1-1.993.116L13 17.003v-6.997a1 1 0 0 1 1-1zm-4 0a1 1 0 0 1 .993.883l.007.116v6.997a1 1 0 0 1-1.993.116L9 17.003v-6.997a1 1 0 0 1 1-1zM13.528 2c1.227-.014 2.326.736 2.796 1.871l.065.174.32.964H19.5A1 1 0 0 1 19.617 7l-.117.007h-15a1 1 0 0 1-.117-1.993L4.5 5.01h2.776l.314-.953a2.987 2.987 0 0 1 2.656-2.05L10.43 2h3.098zm.012 2h-3.11a.986.986 0 0 0-.893.563l-.047.119-.109.327h5.22l-.106-.324a1.008 1.008 0 0 0-.84-.68l-.115-.006z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDelete);
export default __webpack_public_path__ + "static/media/icons-delete.ee1d7c6fb15cbb39293fa0b15970bccd.svg";
export { ForwardRef as ReactComponent };